<div class="container text-white">
    <h1>404 Not Found</h1>
</div>